import {
  Col,
  Row,
  Space,
  Table,
  Tag,
  DatePicker,
  Card,
  message,
  Spin,
  Button,
  Popconfirm,
  Select,
  Tooltip,
  Typography,
  Input,
} from "antd";
import {
  DollarOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  PrinterOutlined,
  SearchOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
  ReloadOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import React, { useEffect, useMemo, useState } from "react";
import DetailModal from "../detail/DetailModal";
import MotionHoc from "../../../utils/MotionHoc";
import { Link } from "react-router-dom";
import {
  baseUrl,
  GET_LAND_BY_DATE,
  HEADERS_EXPORT,
  PUT_INVESTIGATE_LOG,
} from "../../API/apiUrls";

import axios from "axios";
import dayjs from "dayjs";
import CurrencyFormat from "../../../hook/CurrencyFormat";
import LoadLawyers from "../../../hook/LoadLawyers";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { optionsLocat } from "../../../utils/constant/LocatOption";
import { ThaiRangePicker } from "../../../hook/ThaiDatePickerNew";
import AssetsSummary from "../investigateAssets/modal/AssetsSummary";

const Main = () => {
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const [lawyersList, setLoadingData] = LoadLawyers();
  const [isModal, setIsModal] = useState(false);
  const [arrayTable, setArrayTable] = useState();
  const [dataArr, setDataArr] = useState();
  const { RangePicker } = DatePicker;
  const [loading, setLoading] = useState(false);
  const [tableLength, setTableLength] = useState(0);
  const [dataRecord, setDataRecord] = useState();
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [lawyerId, setLawyerId] = useState(userCompany === "3" ? 10 : 5);
  const [lawyersOption, setLawyersOption] = useState();
  const [statusId, setStatusId] = useState("all");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedDate, setSelectedDate] = useState([
    dayjs().startOf("month").subtract(1, "month"),
    dayjs().date(5),
  ]);
  const [arrow, setArrow] = useState("Show");
  const { Option } = Select;

  const [advanceSearch, setAdvanceSearch] = useState(true);
  const [advanceFillter, setAdvanceFillter] = useState(false);
  const [datePickerInvestigateAsset, setDatePickerInvestigateAsset] =
    useState();
  const [searchInput, setSearchInput] = useState();
  const [isModalAssestsSummary, setIsModalAssestsSummary] = useState(false);
  const toggle = () => setAdvanceSearch((v) => !v);
  const toggleFilter = () => setAdvanceFillter((v) => !v);
  const [
    datePickerInvestigateAssetSearch,
    setDatePickerInvestigateAssetSearch,
  ] = useState(() => [
    dayjs().subtract(1, "month").date(11).endOf("day"), // 10 ของเดือนหน้า
    dayjs().date(10).startOf("day"), // 11 ของเดือนนี้
  ]);

  const printOption = [
    {
      value: 1,
      label: "PDF",
    },
    {
      value: 2,
      label: "EXCEL",
    },
  ];

  useEffect(() => {
    setLoadingData(true);
  }, [setLoadingData]);

  useEffect(() => {
    if (lawyersList && dataArr) {
      setOption();
    }
  }, [lawyersList, dataArr]);

  const setOption = () => {
    let companySelect = null;

    if (userCompany === "3") {
      companySelect = lawyersList.filter(
        (item) =>
          item.COMPANY_ID === 3 &&
          (item.ROLE_ID === 3 || item.ROLE_ID === 4 || item.ROLE_ID === 2) &&
          item.ACTIVE_STATUS === 1
      );
    } else {
      companySelect = lawyersList.filter(
        (item) =>
          (item.COMPANY_ID === 1 || item.COMPANY_ID === 2) &&
          (item.ROLE_ID === 3 || item.ROLE_ID === 4) &&
          item.ACTIVE_STATUS === 1
      );
    }

    const options = companySelect.map((item) => ({
      value: item.id,
      label: item.NNAME,
    }));

    // options.unshift({
    //   value: "all", // ค่าที่แทน "ทั้งหมด"
    //   label: "ทั้งหมด", // ข้อความที่แสดงใน dropdown
    // });
    setLawyersOption(options);
  };

  const queryData = async () => {
    setAdvanceFillter(false);
    clearSelectedRows();
    setSearchInput(null);
    setStatusId(null);
    setDatePickerInvestigateAsset(null);
    setLawyerId(null);
    const [start, end] = datePickerInvestigateAssetSearch || [];
    const dStart = dayjs(start);
    const dEnd = dayjs(end);

    if (!dStart.isValid() || !dEnd.isValid()) {
      message.error("โปรดระบุช่วงวันที่ให้ครบ");
      return;
    }
    if (dEnd.isBefore(dStart, "day")) {
      message.error("วันสิ้นสุดต้องไม่น้อยกว่าวันเริ่มต้น");
      return;
    }

    const payload = {
      dateStart: dStart.format("YYYY-MM-DD"),
      dateEnd: dEnd.format("YYYY-MM-DD"),
    };

    await loadData(payload);
  };

  const loadData = async (params) => {
    setLoading(true);
    console.log(params);

    try {
      await axios
        .get(baseUrl + GET_LAND_BY_DATE, { params, headers: HEADERS_EXPORT })
        .then(async (res) => {
          let i = 1;
          if (res.status === 200) {
            const newData = res.data.map((item) => ({
              ...item,
              key: i++,
            }));
            filterData(newData);
            setAdvanceFillter(true);
            console.log("res Role", newData);
          } else {
            message.error("ไม่มีข้อมูล");
            console.log("res Role", res.data);
          }
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err); // ถ้ามีข้อผิดพลาดอื่น ๆ ให้แสดงข้อความนี้
          message.error("ไม่มีข้อมูล");
          setArrayTable([]);
          setDataArr([]);
        });
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
      setArrayTable([]);
      setDataArr([]);
    } finally {
      setLoading(false);
    }
  };

  const filterData = (data) => {
    if (data) {
      let filteredData;
      console.log("data", data);

      if (userCompany === "3") {
        filteredData = data.filter((item) => {
          const branch = item.LOCAT;
          // ถ้า branch เป็น null หรือ undefined ให้ return true ไปเลย (หรือ false ก็ได้ ขึ้นกับความต้องการ)
          if (!branch) return true; // หรือ false ก็ได้ ถ้าอยาก "กรองออก"

          // ถ้า branch มีค่า → เช็กตามปกติ
          return (
            !optionsLocat.some((opt) => branch.includes(opt.label)) ||
            item.CONTNO.includes("UD")
          );
        });
      } else {
        filteredData = data.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return false; // ไม่มี branch ไม่ผ่านเงื่อนไข

          return optionsLocat.some((opt) => branch.includes(opt.label));
        });
      }

      const sortedData = filteredData.sort((a, b) => {
        // ถ้า a ไม่มี judge_date ให้เอาไว้ล่าง
        if (!a.investigation_date && b.investigation_date) return 1;
        // ถ้า b ไม่มี judge_date ให้เอาไว้ล่าง
        if (a.investigation_date && !b.investigation_date) return -1;
        // ถ้าทั้งคู่มี judge_date ให้เปรียบเทียบปกติ (ล่าสุดก่อน)
        if (a.investigation_date && b.investigation_date) {
          return (
            new Date(a.investigation_date) - new Date(b.investigation_date)
          );
        }
        return 0; // ถ้าทั้งคู่เป็น null
      });

      setArrayTable(sortedData);
      setDataArr(filteredData);
      setTableLength(sortedData?.length);
      console.log("newData", sortedData);
      console.log("Length of filtered data:", sortedData?.length);
    } else {
      console.error("data is not an array or is undefined");
      setTableLength(0);
    }
  };

  const sendStatus = async (data) => {
    setLoading(true);
    try {
      await axios
        .put(baseUrl + PUT_INVESTIGATE_LOG, data, {
          headers: HEADERS_EXPORT,
        })
        .then(async (res) => {
          if (res.status === 200) {
            console.log("resQuery", res.data);
          } else {
            message.error("ไม่สามารถส่งข้อมูลได้");
            console.log("ไม่สามารถส่งข้อมูลได้");
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err); // ถ้ามีข้อผิดพลาดอื่น ๆ ให้แสดงข้อความนี้
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("เกิดข้อผิดพลาดในการอัพเดทข้อมูล");
    } finally {
      setLoading(false);
      // if (data.pay_status === 1) {
      //   message.success(`อนุมัติสัญญาเลขท่ี ${data.CONTNO}`);
      // } else {
      //   message.error(`ไม่อนุมัติสัญญาเลขที่ ${data.CONTNO}`);
      // }
      queryData();
    }
  };

  const sendStatusAll = async (rows, status) => {
    if (rows.length === 0) {
      message.error("ไม่มีข้อมูล");
      return;
    }

    setLoading(true);

    try {
      const responses = await Promise.all(
        rows.map((data) =>
          axios.put(baseUrl + PUT_INVESTIGATE_LOG, data, {
            headers: HEADERS_EXPORT,
          })
        )
      );

      // ตรวจสอบผลลัพธ์ของทุก request
      console.log(
        "Updated Data:",
        responses.map((res) => res.data)
      );
    } catch (error) {
      console.error("เกิดข้อผิดพลาดในการอัพเดทข้อมูล", error);
      message.error("เกิดข้อผิดพลาดในการอัพเดทข้อมูล");
    } finally {
      setLoading(false);
      // if (status === 1) {
      //   message.success(`อนุมัติสัญญาจำนวน ${rows.length}`);
      // } else {
      //   message.error(`ไม่อนุมัติสัญญาจำนวน ${rows.length}`);
      // }
      // handleUpdateAll(rows);
      queryData();
    }
  };

  const search = (event) => {
    console.log("query--->", event.target.value);
    setSearchInput(event.target.value);
  };

  const onChangeSelectLawyer = (value) => {
    console.log("onChangeSelectLawyer-->", value);
    setLawyerId(value);
  };

  const onChangeSelectStatus = (value) => {
    console.log("onChangeSelectStatus-->", value);
    setStatusId(value);
  };

  const renderStatus = (record) => {
    let color =
      record.pay_status === 1
        ? "green"
        : record.pay_status === 2
        ? "red"
        : "silver";

    return (
      <Tag color={color} key={record} style={{ textAlign: "center" }}>
        {record.pay_status === 1
          ? "อนุมัติ"
          : record.pay_status === 2
          ? "ไม่อนุมัติ"
          : "รอดำเนินการ"}
      </Tag>
    );
  };

  const renderOpteionStatus = () => {
    return (
      <>
        <Option value={"all"}>
          <span style={{ marginRight: 8 }}>🗂️</span>
          ทั้งหมด
        </Option>
        <Option value={0}>
          <span style={{ marginRight: 8 }}>🕒</span>
          รอดำเนินการ
        </Option>
        <Option value={1}>
          <CheckCircleOutlined style={{ color: "green", marginRight: 8 }} />
          อนุมัติ
        </Option>
        <Option value={2}>
          <CloseCircleOutlined style={{ color: "red", marginRight: 8 }} />
          ไม่อนุมัติ
        </Option>
      </>
    );
  };

  const confirmInsertOne = (data) => {
    const investigateLog = {
      id: data.investigation_log_id,
      investigator_id: data.investigator_id,
      investigation_date: data.investigation_date,
      commission: data.commission,
      investigation_status: data.investigation_status,
      pay_status: 1,
      mark: data.mark,
    };
    console.log(investigateLog);
    sendStatus(investigateLog);
  };

  const cancel = (data) => {
    const investigateLog = {
      id: data.investigation_log_id,
      investigator_id: data.investigator_id,
      investigation_date: data.investigation_date,
      commission: data.commission,
      investigation_status: data.investigation_status,
      pay_status: 2,
      mark: data.mark,
    };
    console.log(investigateLog);
    sendStatus(investigateLog);
  };

  const confirmInsertAll = () => {
    if (selectedRows.length === 0) {
      message.error("กรุณาเลือกสัญญาที่จะอนุมัติก่อน");
      return;
    }

    const dataSend = selectedRows.map((data) => ({
      id: data.investigation_log_id,
      investigator_id: data.investigator_id,
      investigation_date: data.investigation_date,
      commission: data.commission,
      investigation_status: data.investigation_status,
      pay_status: 1,
      mark: data.mark,
    }));

    const status = 1;

    console.log("📦 กำลังส่งข้อมูลทั้งหมด:", dataSend);

    sendStatusAll(dataSend, status); // ✅ ส่งไปยัง API หรือฟังก์ชันที่จัดการต่อ
  };

  const cancelAll = () => {
    if (selectedRows.length === 0) {
      message.error("กรุณาเลือกสัญญาที่จะอนุมัติก่อน");
      return;
    }

    const dataSend = selectedRows.map((data) => ({
      id: data.investigation_log_id,
      investigator_id: data.investigator_id,
      investigation_date: data.investigation_date,
      commission: data.commission,
      investigation_status: data.investigation_status,
      pay_status: 2,
      mark: data.mark,
    }));

    const status = 2;

    console.log("📦 กำลังส่งข้อมูลทั้งหมด:", dataSend);

    sendStatusAll(dataSend, status); // ✅ ส่งไปยัง API หรือฟังก์ชันที่จัดการต่อ
  };

  const onChangeInvestigateDateSearch = (dates) => {
    setDatePickerInvestigateAssetSearch(dates);
  };
  const onChangeInvestigateDate = (dates) => {
    setDatePickerInvestigateAsset(dates);

    console.log(datePickerInvestigateAsset);
  };

  const onQueryDataFilter = () => {
    let result = [...dataArr];
    clearSelectedRows();
    // filter จาก input
    if (searchInput && searchInput.trim() !== "") {
      result = result.filter(
        (item) =>
          item.CONTNO.includes(searchInput.trim()) ||
          item.CUSTOMER_LNAME.includes(searchInput.trim()) ||
          item.CUSTOMER_FNAME.includes(searchInput.trim())
      );
    }

    // filter จาก select (statusId)
    if (statusId) {
      if (statusId === 1) {
        result = result.filter((item) => item.pay_status === 1);
      } else if (statusId === 2) {
        result = result.filter((item) => item.pay_status === 2);
      } else if (statusId === 0) {
        result = result.filter((item) => item.pay_status === null);
      } else {
        result = dataArr;
      }
    }
    if (lawyerId) {
      if (lawyerId !== "all") {
        result = result.filter((item) => item.investigator_id === lawyerId);
      }
    }

    if (datePickerInvestigateAsset && datePickerInvestigateAsset.length === 2) {
      const start = dayjs(datePickerInvestigateAsset[0])
        .startOf("day")
        .valueOf();
      const end = dayjs(datePickerInvestigateAsset[1]).endOf("day").valueOf();

      result = result.filter((item) => {
        const date = dayjs(item.investigation_date).valueOf();
        return date >= start && date <= end;
      });
    }
    console.log("result", result);

    if (result.length > 0) {
      setArrayTable(result);
      setTableLength(result.length);
    } else {
      message.error("ไม่พบข้อมูล");
      setArrayTable(result);
      setTableLength(result.length);
    }
  };

  const clearSelectedRows = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(selectedRowKeys);
    console.log("Selected Row Keys:", selectedRowKeys); // คีย์ของแถวที่เลือก
    console.log("Selected Rows Data:", selectedRows); // ข้อมูลของแถวที่เลือก
    setSelectedRows(selectedRows); // เก็บข้อมูลแถวที่เลือกใน state;
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (rowKeys, selectedRows) => {
      onSelectChange(rowKeys, selectedRows);
    },
  };

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const createAndDownloadExcel = async () => {
    let lawyerName =
      lawyersOption.find((item) => item.value === lawyerId)?.label || "ทั้งหมด";

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(lawyerName);

    // กำหนดชื่อคอลัมน์
    worksheet.columns = [
      { header: "ลำดับ", key: "no", width: 5 },
      { header: "สัญญา", key: "contno", width: 10 },
      { header: "วันที่ลงบันทึกสืบ", key: "investigateDate", width: 15 },
      { header: "สถานะ", key: "investigationStatus", width: 15 },
      { header: "ค่าคอม", key: "commission", width: 15 },
      { header: "สถานะ", key: "status", width: 15 },
      { header: "ผู้สืบทรัพย์", key: "investigatorId", width: 15 },
    ];

    worksheet.getRow(1).eachCell((cell) => {
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.font = { bold: true }; // ทำให้ตัวหนังสือเป็นตัวหนา
    });

    let data = selectedRows.length > 0 ? selectedRows : arrayTable;

    // คำนวณยอดรวมเฉพาะที่อนุมัติ (pay_status === 1)
    const totalApprovedAmount = data
      .filter((item) => item.pay_status === 1)
      .reduce((sum, item) => sum + item.attorney_fees, 0);

    const totalJudgeAmount = data
      .filter((item) => item.commission)
      .reduce((sum, item) => sum + item.commission, 0);

    const totalJudgeAgreementAmount = data
      .filter((item) => item.trial_money_cleared_status === 2)
      .reduce((sum, item) => sum + item.attorney_fees, 0);

    const totalWithdrawCaseAmount = data
      .filter((item) => item.trial_money_cleared_status === 3)
      .reduce((sum, item) => sum + item.attorney_fees, 0);

    const totalFinalCaseAmount = data
      .filter((item) => item.trial_money_cleared_status === 4)
      .reduce((sum, item) => sum + item.attorney_fees, 0);

    const totalReFinanceCaseAmount = data
      .filter((item) => item.trial_money_cleared_status === 5)
      .reduce((sum, item) => sum + item.attorney_fees, 0);

    // เพิ่มข้อมูลลงใน Excel
    data.forEach((item, index) => {
      let row = worksheet.addRow({
        no: index + 1,
        contno: item.CONTNO,
        investigateDate: dayjs(item.investigation_date)
          .add(543, "year")
          .format("D MMM YY"),
        investigationStatus:
          item.investigation_status === 1
            ? "เจอทรัพย์"
            : item.investigation_status === 2
            ? "อายัดเงินได้"
            : item.investigation_status === 0
            ? "ไม่เจอทรัพย์"
            : "-",
        commission: currencyFormatComma(item.commission),
        status:
          item.pay_status === 1
            ? "อนุมัติ"
            : item.pay_status === 2
            ? "ไม่อนุมัติ"
            : "รอดำเนินการ",
        investigatorId:
          lawyersOption?.find((data) => data.value === item.investigator_id)
            ?.label || null,
      });

      // จัดกึ่งกลางทุกเซลล์ในแถว
      row.eachCell((cell) => {
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });
    });

    // ✅ เพิ่มแถวรวมยอด
    let detailRow = worksheet.addRow({
      no: "",
      contno: "",
      cusName: "",
      investigateDate: "",
      investigationStatus: "รวม",
      commission: currencyFormatComma(totalJudgeAmount),
    });

    // ทำให้แถวรวมยอดเป็นตัวหนา
    detailRow.font = { bold: true };

    // จัดกึ่งกลางแถวรวมยอด
    detailRow.eachCell((cell) => {
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // // ✅ เพิ่มแถวรวมยอด
    // let totalRow = worksheet.addRow({
    //   no: "",
    //   contno: "",
    //   cusName: "",
    //   investigateDate: "รวมยอดอนุมัติทั้งหมด",
    //   judgement: currencyFormatComma(totalApprovedAmount),
    //   judgementAgreement: "",
    //   withdrawCase: "",

    //   status: "",
    // });

    // // ทำให้แถวรวมยอดเป็นตัวหนา
    // totalRow.font = { bold: true };

    // // จัดกึ่งกลางแถวรวมยอด
    // totalRow.eachCell((cell) => {
    //   cell.alignment = { horizontal: "center", vertical: "middle" };
    // });

    // สร้างไฟล์และดาวน์โหลด
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // ดาวน์โหลดไฟล์
    saveAs(
      blob,
      `รายงานค่าคอม ${lawyerName} ${dayjs(selectedDate[0])
        .add(543, "year")
        .format("D MMM YY")} - ${dayjs(selectedDate[1])
        .add(543, "year")
        .format("D MMM YY")}.xlsx`
    );
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: "10%",
      render: (text, object, key) => key + 1,
      sorter: {
        compare: (a, b) => a.key - b.key,
        multiple: 5,
      },
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => (
        <Link
          onClick={() => {
            // setIsModal(true);
            setIsModalAssestsSummary(true);
            setDataRecord(record);
          }}
        >
          {record.CONTNO ? record.CONTNO : null}
        </Link>
      ),
    },
    {
      title: "ชื่อ-สกุล",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => (
        <>
          {record.CUSTOMER_TNAME}
          {record.CUSTOMER_FNAME}{" "}
          {record.CUSTOMER_LNAME ? record.CUSTOMER_LNAME : null}
        </>
      ),
    },

    {
      title: "ตรวจทรัพย์",
      align: "center",
      render: (record) => <>{record.department_of_lands}</>,
    },
    {
      title: "ผู้รับผิดชอบ",
      align: "center",
      render: (record) => (
        <>
          {lawyersOption?.map((item) =>
            item.value === record.investigator_id ? item.label : null
          )}
        </>
      ),
    },
    {
      title: "หมายเหตุ",
      dataIndex: "mark",
      key: "mark",
      align: "center",
      render: (text, record) => <>{record.mark}</>,
    },
    {
      title: "วันที่บันทึกการสืบ",
      align: "center",
      render: (record) => (
        <>
          {record.investigation_date
            ? dayjs(record.investigation_date)
                .add(543, "year")
                .format("D MMM YY")
            : null}
        </>
      ),
    },
    // {
    //   title: "วันที่อนุมัติ",
    //   align: "center",
    //   render: (record) => (
    //     <>
    //       {record.attorney_fees_payment_datetime
    //         ? convertDateThaiShort(record.attorney_fees_payment_datetime)
    //         : null}
    //     </>
    //   ),
    // },
    {
      title: "จำนวนเงิน",
      align: "center",
      render: (record) => (
        <>
          {record.investigation_status === 0
            ? "ไม่เจอทรัพย์"
            : record.investigation_status === 1
            ? "เจอทรัพย์"
            : record.investigation_status === 2
            ? "อายัดเงินได้"
            : "-"}
          <br />
          {currencyFormatComma(record.commission)}
        </>
      ),
    },
    {
      title: "สถานะการอนุมัติ",
      align: "center",
      render: (record) => <>{renderStatus(record)}</>,
    },

    {
      title: "การจัดการ",
      align: "center",
      render: (record) => (
        <>
          <Popconfirm
            placement="topLeft"
            title="อัพเดทสถานะ"
            description="คุณต้องการอัพเดทสถานะให้ทนายใช่หรือไม่ ?"
            onConfirm={() => confirmInsertOne(record)}
            onCancel={() => cancel(record)}
            okText="อนุมัติ"
            cancelText="ไม่อนุมัติ"
          >
            <Button style={{ fontSize: "20px", color: "green" }}>
              <DollarOutlined />
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <>
      <Card>
        <Space direction="horizontal" size={8}>
          <Tooltip
            title={advanceFillter ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
            arrow={mergedArrow}
          >
            {!advanceFillter ? (
              <DownSquareOutlined
                style={{ fontSize: 20, color: "blue", marginTop: 20 }}
                onClick={toggleFilter} // antd ส่งค่า checked มาให้
              />
            ) : (
              <UpSquareOutlined
                style={{ fontSize: 20, color: "blue", marginTop: 35 }}
                onClick={toggleFilter} // antd ส่งค่า checked มาให้
              />
            )}
          </Tooltip>
          <Space direction="vertical" size={8} style={{ marginRight: 10 }}>
            <Typography.Text strong>ห้วงเวลาค้นหาข้อมูล</Typography.Text>
            <ThaiRangePicker
              value={datePickerInvestigateAssetSearch}
              onChange={onChangeInvestigateDateSearch}
              size="large"
            />
          </Space>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            size="large"
            style={{
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              fontWeight: "bold",
              background: "linear-gradient(135deg, #667eea, blue)",
              border: "none",
              marginTop: 30,
            }}
            onClick={queryData}
          >
            ค้นหา
          </Button>
        </Space>
      </Card>
      {advanceFillter ? (
        <Card>
          <Row>
            <Col
              span={"12"}
              style={{ textAlign: "start", marginBottom: "10px" }}
            >
              <Space direction="vertical" size={8} style={{ marginRight: 10 }}>
                <Typography.Text strong>
                  ค้นหาสัญญา / ชื่อ-นามสกุล
                </Typography.Text>
                <Input
                  placeholder="ค้นหาสัญญา"
                  onChange={search}
                  style={{
                    width: 200,
                    marginRight: 10,
                  }}
                  value={searchInput}
                  size="large"
                />
              </Space>
              <Space direction="vertical" size={8} style={{ marginRight: 10 }}>
                <Typography.Text strong>ค้นหาสถานะ</Typography.Text>
                <Select
                  placeholder="เลือกสถานะ"
                  optionFilterProp="value"
                  popupMatchSelectWidth={false}
                  onChange={(value) => onChangeSelectStatus(value)}
                  style={{
                    width: "auto",
                  }}
                  size="large"
                  value={statusId}
                >
                  {renderOpteionStatus()}
                </Select>
              </Space>
              <Space direction="vertical" size={8} style={{ marginRight: 10 }}>
                <Typography.Text strong>เลือกทนาย</Typography.Text>

                <Select
                  placeholder="เลือกทนาย"
                  showSearch
                  optionFilterProp="label"
                  onChange={(value, label) =>
                    onChangeSelectLawyer(value, label)
                  }
                  options={lawyersOption}
                  value={lawyerId}
                  style={{
                    width: 150,
                    marginRight: "10px",
                  }}
                  size="large"
                />
              </Space>
            </Col>
            <Col span={"12"} style={{ textAlign: "end", marginBottom: "10px" }}>
              <Space direction="horizontal" size={8}>
                <Tooltip
                  title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
                  arrow={mergedArrow}
                >
                  {!advanceSearch ? (
                    <DownSquareOutlined
                      style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                      onClick={toggle} // antd ส่งค่า checked มาให้
                    />
                  ) : (
                    <UpSquareOutlined
                      style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                      onClick={toggle} // antd ส่งค่า checked มาให้
                    />
                  )}
                </Tooltip>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={() => {
                    clearSelectedRows();
                    setSearchInput(null);
                    setStatusId(null);
                    setDatePickerInvestigateAsset(null);
                    setLawyerId(null);
                  }}
                  style={{
                    color: "red",
                    borderRadius: "8px",
                    fontWeight: "bold",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  ล้าง
                </Button>
                <Button
                  type="default"
                  icon={<FilterOutlined />}
                  size="large"
                  style={{
                    borderRadius: "8px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    fontWeight: "bold",
                    backgroundColor: "#fff7d6",
                    color: "#333",
                    border: "1px solid #ffe58f",
                  }}
                  onClick={onQueryDataFilter}
                  disabled={loading}
                >
                  กรองข้อมูล
                </Button>
              </Space>
            </Col>

            {advanceSearch ? (
              <Col span={24} style={{ textAlign: "start" }}>
                <Space direction="vertical" size={8}>
                  <Typography.Text strong>
                    ค้นหาจากวันที่สืบทรัพย์
                  </Typography.Text>
                  <ThaiRangePicker
                    value={datePickerInvestigateAsset}
                    onChange={onChangeInvestigateDate}
                    size="large"
                  />
                </Space>
              </Col>
            ) : null}
          </Row>
        </Card>
      ) : null}
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            <Col
              span={"12"}
              style={{ textAlign: "start", marginBottom: "10px" }}
            >
              <Popconfirm
                placement="topLeft"
                title="อัพเดทสถานะหลายสัญญา"
                description="คุณต้องการอัพเดทสถานะให้ทนายใช่หรือไม่ ?"
                onConfirm={() => confirmInsertAll()}
                onCancel={() => cancelAll()}
                okText="อนุมัติ"
                cancelText="ไม่อนุมัติ"
              >
                <Button style={{ fontSize: "20px", color: "green" }}>
                  <DollarOutlined />
                </Button>
              </Popconfirm>
            </Col>
            <Col span={"12"} style={{ textAlign: "end", marginBottom: "10px" }}>
              <Tooltip
                placement="bottom"
                title="คลิกเพื่อบันทึกสรุปรายงาน"
                arrow={mergedArrow}
              >
                <PrinterOutlined
                  style={{
                    fontSize: "40px",
                    color: printOption ? "green" : "blue",
                    cursor: "pointer",
                  }}
                  key="print"
                  onClick={() => {
                    createAndDownloadExcel();
                  }}
                />
              </Tooltip>
            </Col>
            <Col span={"24"}>
              <Table
                size="small"
                columns={columns}
                dataSource={arrayTable}
                rowSelection={rowSelection}
                scroll={{ x: 850 }}
                footer={() => (
                  <>
                    <p>จำนวนสัญญาทั้งหมด {tableLength}</p>
                  </>
                )}
                rowKey="key"
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModalAssestsSummary ? (
        <AssetsSummary
          open={isModalAssestsSummary}
          close={setIsModalAssestsSummary}
          dataDefualt={dataRecord}
        />
      ) : null}
      {/* {isModal ? (
        <DetailModal open={isModal} close={setIsModal} dataRec={dataRecord} />
      ) : null} */}
    </>
  );
};

const CommissionInvestigate = MotionHoc(Main);
export default CommissionInvestigate;
